import {
  EyeIcon,
  PencilSquareIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { ColumnDef } from "@tanstack/react-table";

export function TableActionsColumn<T>({
  onMore,
  onEdit,
  onDelete,
  t
}: {
  onMore?: (row: T) => void;
  onEdit?: (row: T) => void;
  onDelete?: (row: T) => void;
  t: any
}): ColumnDef<T> {
  
  return {
    id: "actions",
    header: t('actions'),
    cell: ({ row }) => {
      const rowData = row.original;
      return (
        <div className="flex items-center justify-start gap-2">
          {onMore && (
            <div
              onClick={() => onMore(rowData)}
              className="flex items-center cursor-pointer px-2 py-1 rounded-md  bg-blue-800 text-white hover:text-white"
            >
              <EyeIcon className="h-4 w-4 mr-1" />
              {t('action_view')}
            </div>
          )}
          {onEdit && (
            <div
              onClick={() => onEdit(rowData)}
              className="flex items-center cursor-pointer px-2 py-1 rounded-md bg-yellow-500 text-white  hover:text-yellow"
            >
              <PencilSquareIcon className="h-4 w-4 mr-1" />
              {t('action_edit')}
            </div>
          )}
          {onDelete && (
            <div
              onClick={() => onDelete(rowData)}
              className="flex items-center cursor-pointer px-2 py-1 rounded-md  bg-red-500 text-white  hover:text-white"
            >
              <TrashIcon className="h-4 w-4 mr-1" />
              {t('action_delete')}
            </div>
          )}
        </div>
      );
    },
    enableSorting: false,
    enableColumnFilter: false,
  };
}
